(function($) {
	$( ".language-switcher" ).change(
		function() {
			let target     = $( this )
			.find( ":selected" )
			.data( "target" );
			let cookieName = $( this )
			.find( ":selected" )
			.data( "lang" );

			let domain  = window.location.hostname;
			let expires = new Date(
				new Date().setFullYear( new Date().getFullYear() + 1 )
			);

			if (cookieName) {
				document.cookie =
				"lindy_language=" +
				cookieName +
				";expires=" +
				expires +
				";domain=" +
				domain +
				";secure;path=/";
			}

			window.location.href = target;
		}
	);
})( jQuery );
